import { openBlock as e, createElementBlock as c, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M21.205 6.529c.814.912 1.282 1.96 1.295 3.073v4.924c0 3.58-4.701 6.482-10.5 6.482S1.5 18.106 1.5 14.526c0-.424.005-1.305.01-2.2.005-.887.01-1.786.01-2.271a4.074 4.074 0 0 1-.02-.405c0-.922.312-1.799.873-2.592 3.82-5.397 14.608-5.266 18.832-.53Zm-1.971 6.02C20.46 11.626 21 10.588 21 9.65c0-.691-.282-1.412-.915-2.122-1.726-1.935-4.99-3.08-8.428-3.034-1.772.024-3.45.36-4.872.977l12.449 7.08Zm-1.48.885c-1.543.734-3.537 1.197-5.754 1.197-2.667 0-5.01-.67-6.637-1.675C3.713 11.938 3 10.726 3 9.65c0-.568.189-1.148.598-1.726A6.645 6.645 0 0 1 5.245 6.32l12.51 7.114ZM12 16.131c3.816 0 7.157-1.257 8.996-3.136l.002.646.002.885c0 1.077-.712 2.288-2.363 3.307-1.628 1.005-3.97 1.675-6.637 1.675-2.667 0-5.01-.67-6.637-1.675C3.713 16.813 3 15.603 3 14.526l-.002-.786-.003-.755C4.832 14.87 8.177 16.131 12 16.131Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  l
];
function r(d, s) {
  return e(), c("svg", o, [...n]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
